export * from '@primeuix/themes/lara/select';
export { default } from '@primeuix/themes/lara/select';
